import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import styled from 'styled-components'
import Location from 'components/common/Location'
import { LOCATION_SELECTOR_TARGET_ID } from 'constant'
import Section from '../Section'
import model from '../viewModel'

const BOTStoreLocation = ({ icon, question, title, noHeading, ...props }) =>
  <Fragment>
    <Section
      asset={ icon }
      title={ title }
      subhead={ question }
      targetId={ LOCATION_SELECTOR_TARGET_ID }
      noHeading={ noHeading }>
      <MapWrapper>
        <Field
          botStoreLocation
          fullscreenControl={ false }
          { ...props }
          { ...model.storeSelector }
          component={ Location } />
      </MapWrapper>
    </Section>
  </Fragment>

BOTStoreLocation.propTypes = {
  findMyStoreInstruction: PropTypes.string,
  icon: PropTypes.string,
  name: PropTypes.string,
  noHeading: PropTypes.bool,
  question: PropTypes.string,
  title: PropTypes.string
}

export default BOTStoreLocation

const MapWrapper = styled.div`
  position: relative;
  text-align: center;
`
